<template>
    <div id="app">
        <router-view></router-view>
    </div>
</template>

<script>
require("normalize.css");
export default {
    name: "App",
    components: {},
};
</script>

<style lang='less'>
@import "./css/index.less";
</style>



// WEBPACK FOOTER //
// src/App.vue